import { createFileRoute } from '@tanstack/react-router';
import { SalesProfilePage } from '@/features/admin/sales-profile-page';

export const Route = createFileRoute('/sales/profile')({
  component: () => <SalesProfilePage />,
});
